export default __webpack_public_path__ + "static/media/1870.5ed9b896.png";